import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '../../../shared/services/base-http.service';
import { CONTROLLER_CONSTANTS } from '../../../shared/constants/controller.constants';
import {
  AgentConnectionTest,
  AgentEvent,
  AgentHook,
  AgentHookDelivery,
  AgentIntegration,
  SaveAgentHook,
  SaveAgentIntegration
} from '../interfaces/agent-hooks.interface';

interface ApiResponse<T> {
  isSuccess?: boolean;
  message?: string;
  data?: T;
}

/** The Agent hooks page's calls (admin only): connect to DPE, and say which agent trigger handles which event. */
@Injectable({ providedIn: 'root' })
export class AgentHooksService {
  private readonly base = `/${CONTROLLER_CONSTANTS.AGENT_HOOKS}`;

  constructor(private http: BaseHttpService) {}

  events(): Observable<ApiResponse<AgentEvent[]>> {
    return this.http.get<ApiResponse<AgentEvent[]>>(`${this.base}/Events`);
  }

  integration(): Observable<ApiResponse<AgentIntegration>> {
    return this.http.get<ApiResponse<AgentIntegration>>(`${this.base}/Integration`);
  }

  saveIntegration(body: SaveAgentIntegration): Observable<ApiResponse<AgentIntegration>> {
    return this.http.put<ApiResponse<AgentIntegration>>(`${this.base}/Integration`, body);
  }

  testConnection(): Observable<ApiResponse<AgentConnectionTest>> {
    return this.http.post<ApiResponse<AgentConnectionTest>>(`${this.base}/Integration/Test`, {});
  }

  hooks(): Observable<ApiResponse<AgentHook[]>> {
    return this.http.get<ApiResponse<AgentHook[]>>(`${this.base}/Hooks`);
  }

  createHook(body: SaveAgentHook): Observable<ApiResponse<AgentHook>> {
    return this.http.post<ApiResponse<AgentHook>>(`${this.base}/Hooks`, body);
  }

  updateHook(id: string, body: SaveAgentHook): Observable<ApiResponse<AgentHook>> {
    return this.http.put<ApiResponse<AgentHook>>(`${this.base}/Hooks/${id}`, body);
  }

  deleteHook(id: string): Observable<ApiResponse<unknown>> {
    return this.http.delete<ApiResponse<unknown>>(`${this.base}/Hooks/${id}`);
  }

  testHook(id: string): Observable<ApiResponse<AgentHookDelivery>> {
    return this.http.post<ApiResponse<AgentHookDelivery>>(`${this.base}/Hooks/${id}/Test`, {});
  }

  deliveries(): Observable<ApiResponse<AgentHookDelivery[]>> {
    return this.http.get<ApiResponse<AgentHookDelivery[]>>(`${this.base}/Deliveries`);
  }
}
